<h2 mat-dialog-title class="dialog-header">
  <span class="dialog-title title-large">{{ 'receipts.ui.ricevuta' | transloco }}</span>

  <button
    mat-icon-button
    mat-dialog-close
    type="button"
    [attr.aria-label]="'receipts.ui.chiudi' | transloco"
    class="close-button"
  >
    <i class="fa-regular fa-xmark"></i>
  </button>
</h2>

<mat-dialog-content class="receipt-content">
  <div class="receipt-confirmation">
    <div class="receipt-confirmation-icon" aria-hidden="true">
      <i class="fa-regular fa-check"></i>
    </div>

    <span class="title-medium-emphasized">{{ 'receipts.ui.distintaConfermata' | transloco }}</span>

    <span class="receipt-confirmation-message body-small">
      {{ 'receipts.ui.laRiconciliazioneDegliIncassiVerraEffettuataIlGiornoSuccessivo' | transloco }}
    </span>
  </div>

  <div class="deposit-receipt-card">
    <div class="deposit-receipt-row">
      <span class="body-small">{{ 'receipts.ui.distintaN' | transloco }}</span>
      <span class="body-small-emphasized">{{ data.numeroDistinta }}</span>
    </div>

    <div class="deposit-receipt-row">
      <span class="body-small">{{ 'receipts.ui.dataConferma' | transloco }}</span>
      <span class="body-small-emphasized">{{ data.dataConferma | date: 'dd/MM/yyyy' }}</span>
    </div>

    <div class="deposit-receipt-row">
      <span class="body-small">{{ 'receipts.ui.totaleContanti' | transloco }}</span>
      <span class="body-small-emphasized">{{ formatAmount(data.totaleContanti) }}</span>
    </div>

    <div class="deposit-receipt-row">
      <span class="body-small">{{ 'receipts.ui.totaleAssegni' | transloco }}</span>
      <span class="body-small-emphasized">{{ formatAmount(data.totaleAssegni) }}</span>
    </div>

    <div class="deposit-receipt-divider"></div>

    <div class="deposit-receipt-row deposit-receipt-total">
      <span>{{ 'receipts.ui.totaleDistinta' | transloco }}</span>
      <span>{{ formatAmount(data.totaleDistinta) }}</span>
    </div>

    <div class="deposit-receipt-divider"></div>

    <div class="deposit-receipt-row">
      <span class="body-small">{{ 'receipts.ui.stato' | transloco }}</span>
      <span class="body-small-emphasized">{{ data.situazione }}</span>
    </div>
  </div>

  <div class="deposit-receipt-info">
    <div class="deposit-receipt-info-icon" aria-hidden="true">
      <i class="fa-solid fa-circle-info"></i>
    </div>

    <span class="deposit-receipt-info-text body-medium">
      {{ 'receipts.ui.laRiconciliazioneAvverraAutomaticamenteIlGiornoLavorativoSuccessivoRiceveraiUnaNotificaAlCompletamen' | transloco }}
    </span>
  </div>
</mat-dialog-content>
